import { TelemetrySession } from "../../services/telemetry/telemetry.session";

export const IMPORT_CATEGORY = "ImportTool";

export type ImportFeature =
    | "Import"
    | "ImportEvents"
    | "ImportOrganizations"
    | "ImportContacts"
    | "ImportMasterDefinitions"
    | "ImportBudgets"
    | "ImportSpecialDates";

export class ImportTelemetry {
    static createSession(feature: ImportFeature): TelemetrySession {
        return new TelemetrySession(IMPORT_CATEGORY, feature);
    }
}
